import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=4c2becc4&scoped=true&lang=pug&"
import script from "./Legend.vue?vue&type=script&lang=js&"
export * from "./Legend.vue?vue&type=script&lang=js&"
import style0 from "./Legend.vue?vue&type=style&index=0&id=4c2becc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2becc4",
  null
  
)

component.options.__file = "Legend.vue"
export default component.exports